export enum ExpenseTypeEligibility {
  Reimbursable = 0,
  ReimbursableWithEob = 1,
  ReimbursableWithDoctorsNote = 2,
  ReimbursableWithPrescription = 3,
  NotReimbursable = 4,
  HSANotEligible = 5,
}
